<template>
	<div>
		<a-button type="primary" size="small" @click="showRecord">
			{{ $t('billsReceivable.invoicingInfoRegistration') }}
		</a-button>
		<a-modal
			:title="$t('billsReceivable.invoicingInfoRegistration')"
			:visible="visible_record"
			@cancel="close"
			:destroyOnClose="true"
		>
			<a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 10 }">
				<a-form-item :label="$t('billsReceivable.invoicingTime')">
					<a-date-picker
						:locale="locale"
						:defaultValue="defaultValue"
						:format="dateFormat"
						@change="onChange"
					/>
				</a-form-item>
				<a-form-item :label="$t('billsReceivable.invoiceNumber')">
					<a-textarea
						:placeholder="$t('billsReceivable.invoiceNumber')"
						v-model.trim="initData.invoiceNumber"
						allowClear
						:max-length="255"
						:auto-size="{ minRows: 1, maxRows: 6 }"
						class="textarea-scroll"
					/>
				</a-form-item>
				<a-form-item :label="$t('billsReceivable.remark')">
					<a-textarea
						:placeholder="$t('billsReceivable.remark')"
						v-model.trim="initData.invoiceRemark"
						allowClear
						:max-length="255"
						:auto-size="{ minRows: 1, maxRows: 6 }"
						class="textarea-scroll"
					/>
				</a-form-item>
			</a-form>
			<template slot="footer" class="footer">
				<a-button key="back" @click="confirm" type="primary">
					{{ $t('sure') }}
				</a-button>
				<a-button key="cancel" @click="close">
					{{ $t('cancel') }}
				</a-button>
			</template>
		</a-modal>
	</div>
</template>

<script>
import moment from "moment";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import { searchReqParam } from "../../../../utils/searchReqParam";
import { updateInvoiceRecord } from "../../../../api/receivable";

let initData = {
	billingReportId: "",
	billingTime: moment(),
	currentUserId: "",
	invoiceNumber: "",
	invoiceRemark: "",
};
export default {
	name: "invoice-record",
	props: {
		selectedRows: {
			type: Array,
			default() {
				return [];
			},
		},
	},
	data() {
		return {
			locale,
			initData,
			req: searchReqParam(),
			visible_record: false,
			dateFormat: "YYYY-MM-DD",
			defaultValue: moment(),
		};
	},
	methods: {
		moment,
		showRecord() {
			if (this.selectedRows.length >= 1) {
				this.initData.billingReportId = this.selectedRows[0].billingReportId;
				this.initData.invoiceNumber = this.selectedRows[0].invoiceNumber;
				this.initData.invoiceRemark = this.selectedRows[0].invoiceRemark;
				if (this.selectedRows[0].billingTime) {
					this.defaultValue = moment(this.selectedRows[0].billingTime);
				}
				this.initData.billingTime = this.defaultValue.format("YYYY-MM-DD");
				this.visible_record = true;
			} else {
				this.$message.error(this.$t('businessDispatch.feedbackTransportNode[0]'));
			}
		},
		close() {
			this.params = {};
			this.initData = {};
			this.visible_record = false;
		},
		confirm() {
			this.req.params = this.initData;
			updateInvoiceRecord(this.req).then((res) => {
				let temp = JSON.parse(res.data);
				if (!temp.success || temp.code != 0) {
					this.$message.error(temp.msg);
					this.visible_record = false;
					return;
				}
				this.$message.success(temp.msg);
				this.visible_record = false;
				this.$emit("success", temp.msg);
			});
		},
		onChange(value, dateString) {
			this.initData.billingTime = dateString;
		},
	},
};
</script>

<style lang="less" scoped>
.textarea-scroll {
	::-webkit-scrollbar {
		width: 0px;
		height: 8px;
	}
}
/deep/ .ant-calendar-picker {
	width: 100%;
}
</style>
